import { Card, CardContent } from "@/components/ui/card";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

interface KpiCardProps {
  label: string;
  value: string;
  sublabel?: string;
  trend?: "up" | "down" | "flat";
  icon?: React.ComponentType<{ className?: string }>;
  color?: string;
}

export function KpiCard({
  label,
  value,
  sublabel,
  trend,
  icon: Icon,
  color = "#2563eb",
}: KpiCardProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
              {label}
            </p>
            <p className="text-2xl font-bold mt-1 tabular-nums" style={{ color }}>
              {value}
            </p>
            {sublabel && (
              <p className="text-xs text-muted-foreground mt-0.5">{sublabel}</p>
            )}
          </div>
          <div className="flex flex-col items-end gap-1">
            {Icon && (
              <div
                className="flex items-center justify-center w-8 h-8 rounded-lg"
                style={{ backgroundColor: `${color}18` }}
              >
                <Icon className="w-4 h-4" style={{ color }} />
              </div>
            )}
            {trend && (
              <span className="flex items-center gap-0.5 text-xs">
                {trend === "up" && <TrendingUp className="w-3 h-3 text-green-500" />}
                {trend === "down" && <TrendingDown className="w-3 h-3 text-red-500" />}
                {trend === "flat" && <Minus className="w-3 h-3 text-gray-400" />}
              </span>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
